module.exports = __webpack_public_path__ + "static/media/icon-dashboard-cart.e5e68f85.svg";